<template>
	<alert :unclosable="true" icon="fa-lock" classes="alert-warning" message="This feature is unavailable in the Free Tier" :visible="true">
	</alert>
</template>

<script>
	import Alert from "@/components/Alert"
	export default {
		name: "FreemiumLockedAlert",
		components: {
			Alert
		}
	}
</script>